import React from 'react';
import { Col, Row, Radio, Form, Input, Select, message } from 'antd';
import moment from 'moment';
import { CaretDownOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import images from 'constants/images';
import { DELETE_TEAM_MEMBER } from 'graphql/mutations/usersTeamMutation';
import { useMutation } from '@apollo/client';

import MinusFillIcon from 'components/Icons/MinusFillIcon';
import PlusFillIcon from 'components/Icons/PlusFillIcon';
import DeleteIcon from 'components/Icons/ClearXIcon';

const daystrial = parseInt(process.env.REACT_APP_DAYS_TRAIL) || 14;

const maxUsersInvitation = parseInt(process.env.REACT_APP_MAX_USER_INVITE) || 25;

const jobs = [
  { text: 'Manager', value: 'manager' },
  { text: 'Editor', value: 'editor' },
];

const { Option } = Select;

const Pricing = ({
  user,
  usersTeam,
  setUsersTeam,
  changeUserTeamCount,
  newUsersCount,
  addRemoveRef,
  usersToBeDeleted,
  setUsersToBeDeleted,
  plan,
  setPlan,
  setNewUsersCount,
}) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.1,
      },
    },
  };

  const leftGroupVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  const rightGroupVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.2,
      },
    },
  };

  const imageVariants = {
    hidden: {
      opacity: 0,
      y: 50,
      scale: 0.5,
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: 'spring',
        stiffness: 350,
        damping: 22,
        mass: 0.7,
        duration: 0.5,
      },
    },
  };

  const [removeOneTeamMember] = useMutation(DELETE_TEAM_MEMBER, {
    onCompleted: ({ removeOneTeamMember }) => {
      if (removeOneTeamMember) {
        let updatedUsersTeam = usersTeam.filter((team) => {
          return team._id !== usersToBeDeleted._id;
        });
        if (updatedUsersTeam) {
          message.success('User removed successfully');
        }
      }
    },
    onError: (error) => {
      console.log('error::::', error);
    },
  });

  const doRemoveUserTeam = (_id) => {
    if (usersTeam.length > 0) {
      removeOneTeamMember({ variables: { uid: _id } });
      let newUserTeam = usersTeam.filter((user) => {
        return user._id !== _id;
      });
      usersTeam = newUserTeam;
    }
  };

  const { isLegacy } = user?.paymentStatus;

  const getTrialTime = () => {
    if (!user) {
      return 666;
    }

    const timespan = new Date() - new Date(user.stopperAnchor || user.createdAt);
    const dayspan = timespan / 1000 / 60 / 60 / 24;

    return daystrial - dayspan;
  };

  const trialTime = getTrialTime();
  const trial = trialTime >= 0 ? true : false;

  let { nextPaymentDate } = user?.paymentStatus;
  let renewaldate = nextPaymentDate && moment(nextPaymentDate).format('MMM Do, YYYY');

  if (isLegacy) {
    nextPaymentDate = null;
    renewaldate = null;
  } else if (!renewaldate && trial) {
    renewaldate = moment().add(trialTime, 'days').format('MMM Do, YYYY');
  }

  const userCount = usersTeam.length + newUsersCount + 1;
  const monthlyRate = 19;
  const yearlyDiscountedRate = 12;

  return (
    <div className="pricing plans">
      <div className="heading-wrap">
        <Col className="top-logo">
          <img src={images.LOGO} className="logo" alt="prospero-logo" height="16" />
        </Col>
        <div className="pill free-trial-pill">
          <span>Enjoy a free 14-day trial 🙌</span>
        </div>
        <h3 className="heading-text">Upgrade to Win More Clients</h3>
      </div>
      <Col smd={24} className="plan-type-toggler">
        <div className="toggle-switches">
          <Radio.Group
            value={plan}
            onChange={(e) => {
              const planType = e.target.value;
              setPlan(planType);
            }}>
            <Radio.Button
              className="toggle-control-texts"
              value="yearly"
              checked={plan === 'yearly' ? true : false}>
              <div className="badge-overlay">
                <span className="badge top-right red">Save 37%</span>
              </div>
              <div className="toggle-control-texts">
                <p className="switch-toggle-button-text"> Billed Annually</p>
                <h4 className="price">{'$' + yearlyDiscountedRate * userCount}/month</h4>
              </div>
            </Radio.Button>
            <Radio.Button value="monthly" checked={plan === 'monthly' ? true : false}>
              <div className="toggle-control-texts">
                <p className="switch-toggle-button-text"> Billed Monthly </p>
                <h4 className="price">{'$' + monthlyRate * userCount}/month</h4>
              </div>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Col>
      <Col className="plans-content">
        <Row className="plans-info">
          <Col xs={24} md={24}>
            <Row
              className={`plans-payment-buttons trial ${
                usersTeam.length > 0 || newUsersCount > 0 ? 'count-container-visible' : ''
              }`}>
              <div className="trial-user-select-plan">
                <p className="team-invite-text">How many teammates to invite?</p>
                <div className="trial-plan-count-container">
                  <button
                    className="ant-btn trial-plan-count-button"
                    type="button"
                    left="true"
                    onClick={() => {
                      const currentValue = usersTeam.length + newUsersCount + 1;
                      const minValue = usersTeam.length > 0 ? usersTeam.length + 1 : 1;
                      if (currentValue > minValue) {
                        changeUserTeamCount(currentValue - 1);
                      }
                    }}
                    disabled={
                      usersTeam.length + newUsersCount + 1 <=
                      (usersTeam.length > 0 ? usersTeam.length + 1 : 1)
                    }>
                    <MinusFillIcon />
                  </button>
                  <p className="trial-plan-count">{usersTeam.length + newUsersCount + 1}</p>
                  <button
                    className="ant-btn trial-plan-count-button"
                    type="button"
                    right="true"
                    onClick={() => {
                      const currentValue = usersTeam.length + newUsersCount + 1;
                      if (currentValue < maxUsersInvitation) {
                        changeUserTeamCount(currentValue + 1);
                      }
                    }}
                    disabled={usersTeam.length + newUsersCount + 1 >= maxUsersInvitation}>
                    <PlusFillIcon />
                  </button>
                </div>
              </div>
              {!usersTeam.length && !newUsersCount && (
                <motion.div
                  className="vector-groups"
                  variants={containerVariants}
                  initial="hidden"
                  animate="visible">
                  <motion.div className="vector-group-one" variants={leftGroupVariants}>
                    <motion.img
                      src={images.GROUP_2705}
                      alt="vector-group"
                      variants={imageVariants}
                    />
                    <motion.img
                      src={images.GROUP_2708}
                      alt="vector-group"
                      variants={imageVariants}
                    />
                  </motion.div>
                  <motion.div className="vector-group-two" variants={rightGroupVariants}>
                    <motion.img
                      src={images.GROUP_2709}
                      alt="vector-group"
                      variants={imageVariants}
                    />
                    <motion.img
                      src={images.GROUP_2707}
                      alt="vector-group"
                      variants={imageVariants}
                    />
                  </motion.div>
                </motion.div>
              )}
              <div
                className={`form-container ${
                  usersTeam.length > 0 || newUsersCount > 0 ? 'visible' : ''
                }`}>
                <Form.List name="users" autoComplete="off">
                  {(fields, { add, remove }) => {
                    addRemoveRef.current = { add, remove };
                    return (
                      <>
                        {fields.map((field, index) => (
                          <div key={`AddUser${index}`} className="user-group-container">
                            <div className="user-group">
                              <div
                                className={`user-info-container ${
                                  usersTeam[field.key]?.emails[0]?.verified === false
                                    ? 'user-info-container-unverified'
                                    : ''
                                }`}
                                key={`user-info-container-${index}`}>
                                <Form.Item
                                  label=""
                                  className="user-group-item user-group-item-email"
                                  name={[field.name, 'email']}
                                  rules={[
                                    {
                                      required: true,
                                      type: 'email',
                                      message: 'Please enter an email',
                                    },
                                  ]}>
                                  <Input
                                    placeholder="Teammate's email address"
                                    disabled={index >= usersTeam.length ? false : true}
                                  />
                                </Form.Item>
                                <Form.Item
                                  label=""
                                  className="user-group-item user-group-item-role"
                                  name={[field.name, 'role']}
                                  initialValue="manager"
                                  rules={[{ required: true, message: 'Role required' }]}>
                                  <Select
                                    suffixIcon={<CaretDownOutlined color="blue" />}
                                    disabled={index >= usersTeam.length ? false : true}>
                                    {jobs.map((job) => (
                                      <Option key={job.value} value={job.value}>
                                        {job.text}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                                <DeleteIcon
                                  className="remove-icon"
                                  onClick={() => {
                                    if (index < usersTeam.length) {
                                      const member = usersTeam[index];
                                      const tempUsersToBeDeleted = [
                                        ...(usersToBeDeleted || []),
                                        {
                                          _id: member._id,
                                          email: member.emails[0].address,
                                          role: member.roles[0],
                                        },
                                      ];
                                      setUsersToBeDeleted(tempUsersToBeDeleted);
                                      doRemoveUserTeam(member._id);
                                      setUsersTeam((prev) => prev.filter((_, i) => i !== index));
                                    } else {
                                      setNewUsersCount((prev) => prev - 1);
                                    }
                                    remove(field.name);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    );
                  }}
                </Form.List>
              </div>
            </Row>
          </Col>
        </Row>
      </Col>
    </div>
  );
};

Pricing.defaultProps = {
  user: {},
};

Pricing.propTypes = {
  user: PropTypes.instanceOf(Object).isRequired,
  setPlan: PropTypes.func,
  usersTeam: PropTypes.instanceOf(Array),
  setUsersTeam: PropTypes.func,
  changeUserTeamCount: PropTypes.func,
  newUsersCount: PropTypes.number,
  addRemoveRef: PropTypes.instanceOf(Object),
  usersToBeDeleted: PropTypes.instanceOf(Array),
  setUsersToBeDeleted: PropTypes.func,
  plan: PropTypes.string,
};

export default Pricing;
